<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
                    <app-reactive-form-builder
                        #builderRef
                        (stableValueChanges)="stableValueChanges($event)"
                        (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
                        (goBack)="goBack()"
                        [form]="reactiveForm.formFields"
                        [id]="reactiveFormRecordId"
                        [request]="request"
                        [getRequest]="visitasApi.visitasPereira.GET"
                        [previousData]="initialPreviousData">
                    </app-reactive-form-builder>
                </ng-container>
            </div>
        </div>
    </div>
</p-panel>

<ng-template #reactiveFormLoadingState>
    <div class="p-3 text-center" role="status" aria-live="polite">
        <div *ngIf="!reactiveFormLoadingError" class="text-muted">
            {{ reactiveFormLoadingLabel }}
        </div>
        <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
            {{ reactiveFormLoadingError }}
        </div>
    </div>
</ng-template>
